import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validate the passsword contains the required pattern
export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const pattern = [
    /\d+/, // numeric values
    /[a-z]+/, // lowercase values
    /[A-Z]+/, // uppercase values
    /\W+/, // special characters
    /^\S+$/, // no whitespace allowed
  ];

  // Not working with input blur
  // if (control.errors && !control.errors.invalidPassword) {
  // console.log('other error ?:', control.errors);
  // return if another validator has already found an error on the control
  // return;
  // }

  let valid = true;

  pattern.forEach((pattern) => (valid = valid && pattern.test(control.value)));

  return control.value && !valid ? { invalid: { value: control.value } } : null; // invalidPassword
}

// if (!control.value.startsWith('https') || !control.value.includes('.io')) {
// return { invalidPassword: true };
// }

// control.setErrors({ pattern: true });
